import { Controller } from "stimulus";
import displayFlashMessage from "../../functions/displayFlashMessage";
import download from "../../functions/download";

export default class extends Controller {
  download() {
    event.preventDefault();
    download(this.value, this.filename);
    displayFlashMessage(this.notificationText);
  }

  get notificationText() {
    return this.element.dataset.notificationText;
  }

  get value() {
    return this.element.dataset.value;
  }

  get filename() {
    return this.element.dataset.filename;
  }
}
